
import { Component, Vue } from 'vue-property-decorator'
import BacButton from '../../components/BacButton.vue'
import BacModal from '../../components/BacModal.vue'
import BacInput from '../../components/BacInput.vue'
import FixedValueDiscounts from '../../components/admin/discounts/FixedValueDiscounts.vue'
import { Discount } from '../../lib/models/Discount'
import { Rally } from '../../lib/models/Rally'
import { RallyRound } from '../../lib/models/RallyRound'
import UIkit from 'uikit'
import { Http } from '@/lib/utils/Http'
import { DateUtils } from '@/lib/utils/DateUtils'

@Component({ components: { BacButton, BacModal, BacInput, FixedValueDiscounts } })
export default class Discounts extends Vue {
    headers = [
      { text: 'Rally', value: 'rally', width: 20 },
      { text: 'Rally Runde', value: 'rallyRound', width: 20 },
      { text: 'Customer ID', value: 'customerId', width: 120 },
      { text: 'E-Mail', value: 'email', width: 120 },
      { text: 'Name', value: 'name', width: 120 },
      { text: 'Prozent', value: 'percent', width: 10 },
      { text: 'Eingelöst', value: 'redeemed', width: '200px' },
      { text: 'Info', value: 'info', width: 20 },
      { text: 'Läuft nie ab', value: 'endlessRedeemable', width: 10 },
      { text: 'Gültig ab', value: 'validFrom', width: 10 },
      { text: 'Gültig bis', value: 'validTil', width: 10 },
      { text: 'Aktionen', value: 'actions', width: 20 }
    ]

    DateUtils = DateUtils

    search = ''

    discounts: Discount[] = []
    rallies: Rally[] = []
    rounds: RallyRound[] = []

    selectedDiscount = new Discount()
    isAddingDiscount = false
    isDeletingDiscount = false

    mounted () {
      this.loadDiscounts()
      this.loadRallies()
      this.loadRallyRounds()
    }

    get rallyRounds () {
      return this.rounds.filter(round => {
        return round.rallyId === this.selectedDiscount.rallyId
      })
    }

    async saveDiscount () {
      if (this.isAddingDiscount) {
        return
      }
      this.isAddingDiscount = true
      const method = this.selectedDiscount.id ? 'PUT' : 'POST'
      const apiRoute = this.selectedDiscount.id ? `/api/discount/${this.selectedDiscount.id}` : '/api/discount/'
      const res = await Http.request(apiRoute, {
        method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.selectedDiscount)
      })
      if (res.status !== 200) {
        UIkit.notification({
          message: 'Es ist ein Fehler aufgetreten, bitte überprüfe deine Eingaben!',
          status: 'success',
          timeout: 5000,
          pos: 'bottom-center'
        })
      } else {
        UIkit.notification({
          message: 'Discount gespeichert!',
          status: 'success',
          timeout: 5000,
          pos: 'bottom-center'
        })
        UIkit.modal('#add-discount-modal').hide()
      }
      setTimeout(() => { this.isAddingDiscount = false }, 1000)
      this.selectedDiscount = new Discount()
      this.loadDiscounts()
    }

    async deleteDiscount () {
      if (this.isDeletingDiscount) {
        return
      }
      this.isDeletingDiscount = true
      const res = await Http.request(`/api/discount/${this.selectedDiscount.id}`, {
        method: 'DELETE'
      })

      if (res.status !== 200) {
        UIkit.notification({
          message: 'Es ist ein Fehler aufgetreten!',
          status: 'success',
          timeout: 5000,
          pos: 'bottom-center'
        })
      } else {
        UIkit.notification({
          message: 'Discount gelöscht!',
          status: 'success',
          timeout: 5000,
          pos: 'bottom-center'
        })
        UIkit.modal('#delete-discount-modal').hide()
      }

      setTimeout(() => { this.isDeletingDiscount = false }, 1000)
      this.selectedDiscount = new Discount()
      this.loadDiscounts()
    }

    getRoundFromId (id: number): RallyRound {
      const nullRound = new RallyRound()
      nullRound.name = '-'
      if (!id) {
        return nullRound
      }

      const foundRallyRound = this.rounds.find(round => {
        return round.id === id
      })
      if (!foundRallyRound) {
        return nullRound
      }
      return foundRallyRound
    }

    getRallyFromId (id: number): Rally {
      const nullRally = new Rally()
      nullRally.name = '-'
      if (!id) {
        return nullRally
      }
      const foundRally = this.rallies.find(rally => {
        return rally.id === id
      })
      if (!foundRally) {
        return nullRally
      }
      return foundRally
    }

    async loadDiscounts () {
      this.discounts = (await Discount.getAll({})).slice().reverse()
    }

    async loadRallies () {
      this.rallies = await Rally.getAll({})
    }

    async loadRallyRounds () {
      this.rounds = await RallyRound.getAll({ params: ['admin-permission'] })
    }

    get items () {
      return this.discounts
    }
}
